/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { protectedPageList, unprotectedPageList } from './page-list';

export const ContentRouter = ({ isProtectedRouts }) => {
	const pageList = isProtectedRouts ? protectedPageList : unprotectedPageList;

	return (
		<Switch>
			{Object.keys(pageList).map(key => {
				const Component = pageList[key].component;

				return (
					<Route
						key={key}
						path={pageList[key].path}
						exact={pageList[key].exact}
						render={props => (
							<Component
								{...props}
								name={pageList[key].name}
								host={pageList[key].host}
								withoutMenu={pageList[key].withoutMenu}
							/>
						)}
					/>
				);
			})}
		</Switch>
	);
};

ContentRouter.propTypes = {
	isProtectedRouts: PropTypes.bool,
};
